import * as React from "react";

const { Row, Col, FormGroup, ControlLabel } = require("react-bootstrap");

interface NameFieldProps {
  hint?: string;
  labelValue?: string;
  name?: {
    first: string;
    middle: string;
    last: string;
    suffix: string;
  };
  onChange: Function;
  onFocus?: React.FocusEventHandler<{}>;
  onBlur?: React.FocusEventHandler<{}>;
  autoComplete?: string;
}

class NameField extends React.Component<NameFieldProps, any> {
  constructor(props: NameFieldProps) {
    super(props);
    this.state = {
      first: props.name && props.name.first ? props.name.first : "",
      middle: props.name && props.name.middle ? props.name.middle : "",
      last: props.name && props.name.last ? props.name.last : "",
      suffix: props.name && props.name.suffix ? props.name.suffix : "",
    };
  }

  handleOnChange(e) {
    const newState = {
      ...this.state,
      [e.target.name]: e.target.value,
    };

    this.setState(newState, () => {
      this.props.onChange(newState);
    });
  }

  render() {
    const { labelValue, hint, onFocus, onBlur, autoComplete } = this.props;

    const sharedProps = {
      onFocus: onFocus || null,
      onBlur: onBlur || null,
      onChange: this.handleOnChange.bind(this),
      autoComplete: autoComplete || "off",
    };

    return (
      <FormGroup>
        <ControlLabel>{labelValue}</ControlLabel>
        {hint && <span className="help-block">{hint}</span>}
        <Row>
          <Col md={3}>
            <input
              className="form-control"
              name="first"
              placeholder="[first]"
              value={this.state.first}
              {...sharedProps}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <input
              className="form-control"
              name="middle"
              placeholder="[middle]"
              value={this.state.middle}
              {...sharedProps}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <input
              className="form-control"
              name="last"
              placeholder="[last]"
              value={this.state.last}
              {...sharedProps}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <input
              className="form-control"
              name="suffix"
              placeholder="[suffix]"
              value={this.state.suffix}
              {...sharedProps}
            />
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

export default NameField;
